export default "__VITE_ASSET__DqBncbob__"